import React, { useEffect, useState } from 'react';
import { Button, Card, Descriptions, Empty, List, Modal, Space, Tag, message } from 'antd';
import { api, getAdminErrorMessage } from '../lib/api';

const typeLabels = { PERSONAL: '个人', COMPANY: '公司', GOVERNMENT: '政府' };

export default function VerificationReview() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/verification/pending');
      setItems(response.data || []);
    } catch (error) {
      message.error(getAdminErrorMessage(error, '加载认证申请失败'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const review = (item, approved) => {
    const action = async (reason) => {
      try {
        if (approved) {
          await api.post(`/api/verification/${item.id}/approve`);
        } else {
          await api.post(`/api/verification/${item.id}/reject`, { reason });
        }
        message.success(approved ? '认证已通过' : '认证已驳回');
        load();
      } catch (error) {
        message.error(getAdminErrorMessage(error, '审核失败'));
      }
    };
    if (approved) {
      Modal.confirm({ title: '通过认证', content: `确认通过${typeLabels[item.verificationType] || ''}认证？`, onOk: () => action('') });
    } else {
      Modal.confirm({
        title: '驳回认证',
        content: '确认驳回该申请？',
        onOk: () => action('认证材料不符合要求，请补充后重新提交')
      });
    }
  };

  return (
    <Card title="身份认证审核" extra={<Button onClick={load} loading={loading}>刷新</Button>}>
      {items.length === 0 && !loading ? <Empty description="暂无待审核认证" /> : (
        <List
          loading={loading}
          dataSource={items}
          renderItem={(item) => (
            <List.Item actions={[
              <Button type="primary" onClick={() => review(item, true)}>通过</Button>,
              <Button danger onClick={() => review(item, false)}>驳回</Button>
            ]}>
              <List.Item.Meta
                title={<Space>{item.username}<Tag color="blue">{typeLabels[item.verificationType] || item.verificationType}</Tag></Space>}
                description={<Descriptions size="small" column={2}>
                  <Descriptions.Item label="姓名">{item.realName}</Descriptions.Item>
                  <Descriptions.Item label="证件号">{item.idCardNumber}</Descriptions.Item>
                  <Descriptions.Item label="单位">{item.organizationName || '-'}</Descriptions.Item>
                  <Descriptions.Item label="统一社会信用代码/证件编号">{item.credentialNumber || '-'}</Descriptions.Item>
                  <Descriptions.Item label="材料说明">{item.materialsNote || '-'}</Descriptions.Item>
                </Descriptions>}
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
}
